
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { WhereToWatch } from './whereToWatch'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="p" components={components}>{`Am 14. April starteten die letzten sechs Folgen von «Game of Thrones». Wer sitzt am Ende auf dem Eisernen Thron? Wer starb? Welche der vielen Theorien rund ums Finale gingen in Erfüllung, welche nicht? Darauf konnten Sie in unserem Tippspiel setzen.`}</MDXTag>
<div className='infographic'>
<MDXTag name="h3" components={components}>{`Und auf unserem Eisernen Podest sind:`}</MDXTag>
<div className='ui one inverted statistics'>
  <div className='ui statistic'>
    <div className='value'>
      <img src={require('images/trophy.svg')} />
    </div>
    <div className='label'>Christophe Greder</div>
  </div>
</div>
<div className='ui one inverted statistics'>
  <div className='ui statistic'>
    <div className='value'>
      <img src={require('images/trophy.svg')} />
    </div>
    <div className='label'>Rosmarie Adelsberger</div>
  </div>
</div>
<div className='ui one inverted statistics'>
  <div className='ui statistic'>
    <div className='value'>
      <img src={require('images/trophy.svg')} />
    </div>
    <div className='label'>Leonie Hauser</div>
  </div>
</div>
<MDXTag name="p" components={components}>{`Sie gewinnen je ein Jahres-Digitalabo eines Tamedia-Titels ihrer Wahl. Herzlichen Glückwunsch!`}</MDXTag>
</div>
<div className='ui pointsDescription infographic'>
<div className='titleWrapper'>
<MDXTag name="h3" components={components}>{`Spielregeln`}</MDXTag>
</div>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Wiedergänger (Wights) und Weisse Wanderer (White Walkers) gelten als tot. Es sei denn, sie werden im Lauf der letzten Staffel wieder zu Menschen.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Auferstandene (wie Jon Snow und Beric) gelten als lebend.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Bei unklaren Fällen entschied unsere Jury.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Bei Punktegleichstand gewann die Person, deren Schätzung bei der letzten Frage am genausten ist.`}</MDXTag>
</MDXTag>
</div>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  